<template>
	<div 
		class="
			p-2 rounded-lg  
			bg-neutral-200 dark:bg-neutral-800
			border-border dark:border-border
		"
	>
		<slot/>
	</div>
</template>

<script setup>

</script>

<style scoped>

</style>